import { Button } from '@/components/base/button';
import CopyTool from '@/components/base/copytool';
import Section from '@/components/base/section';
import { faInstagram, faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AffiliateModal } from './change-affiliate-modal';
import { InviteModal } from './invite-modal';

export function ManageAffiliateCode({
  refcode,
}: {
  refcode: string;
}): JSX.Element {
  const [openChangeAffiliate, setOpenChangeAffiliate] = useState(false);
  const [openInviteModal, setOpenInviteModal] = useState(false);
  const { t } = useTranslation();

  return (
    <Section variant="secondary" className="h-full">
      <div className="grid h-full grid-cols-3 gap-4">
        <div className="col-span-3 flex h-full w-full flex-col justify-between gap-4 md:col-span-2">
          <div className="flex w-full flex-col items-baseline justify-between sm:flex-row">
            <span>{t('affiliateDashboard.referralCodeTitle')}</span>

            <InviteModal
              isOpen={openInviteModal}
              onOpenChange={setOpenInviteModal}
            >
              <Button className="absolute right-4 top-3 h-fit w-fit justify-center truncate rounded-lg px-3 py-1.5 md:top-6 md:w-fit">
                {t('affiliateDashboard.invite.inviteUsers')}
              </Button>
            </InviteModal>
          </div>

          <div className="flex w-full flex-col gap-4">
            <div className="flex flex-col items-center gap-1 xl:flex-row">
              <CopyTool className="px-2 py-1.5" text={refcode} />
              <AffiliateModal
                refCode={refcode}
                isOpen={openChangeAffiliate}
                onOpenChange={setOpenChangeAffiliate}
                className="flex w-fit justify-end md:justify-center"
              >
                <Button
                  variant="outlined"
                  className="h-full w-fit justify-start truncate rounded-lg px-3 py-2.5 md:w-full md:justify-center md:py-1.5"
                >
                  {t('affiliateDashboard.referralCodeEditButton')}
                </Button>
              </AffiliateModal>
            </div>
            <CopyTool
              className="px-2 py-1.5"
              text={`https://monevis.com/?ref=${refcode}`}
            />
            <CopyTool
              className="px-2 py-1.5"
              text={`https://partners.monevis.com/auth/registration/?ref=${refcode}`}
            />
          </div>

          <div className="flex flex-col gap-10 md:flex-row ">
            <div className="flex flex-col gap-2">
              <span> {t('affiliateDashboard.referralCodePost')}</span>
              <div className="flex gap-5">
                <a
                  rel="noopener"
                  target="_blank"
                  href="https://twitter.com/intent/tweet?text=Join%20Monevis%20and%20start%20earning!%20Sign%20up%20now%20%F0%9F%92%B8%20%F0%9F%9A%80%20%F0%9F%91%89%20monevis.com/?ref=SZOZKHFR"
                >
                  <FontAwesomeIcon className="h-6 w-6" icon={faXTwitter} />
                </a>
                <a
                  rel="noopener"
                  target="_blank"
                  href="https://www.instagram.com/"
                >
                  <FontAwesomeIcon className="h-6 w-6" icon={faInstagram} />
                </a>
              </div>
            </div>
          </div>
        </div>

        <img
          className="my-auto hidden md:block"
          src="/images/affiliates.png"
          alt="affiliates"
        />
      </div>
    </Section>
  );
}
